const normalize_query = (query: string): string => query.trim().toLowerCase();

export default normalize_query;
